/* eslint-disable import/prefer-default-export */
const UI_SESSION_KEY = 'ui-session';
const LOW_CONTRAST_RATING = 2.2;
const DEFAULT_CONTRAST_RATING = 2.8;
const BACKGROUND_CONTRAST_RATING = 1.5;

export {
  UI_SESSION_KEY,
  BACKGROUND_CONTRAST_RATING,
  LOW_CONTRAST_RATING,
  DEFAULT_CONTRAST_RATING
};
